import { buildAxiosInstance } from '../utils/apiUtils'
import { cardAddProxy } from '../components/CardAddSlideOver/cardAddProxy'

interface ResponseData {
  sessionToken: string
}

interface Response {
  data: ResponseData | null
  error: string | null
}

export async function executeFetchSessionToken (): Promise<Response | null | undefined> {
  cardAddProxy.apiCallSessionToken.loading = true
  cardAddProxy.apiCallSessionToken.error = null
  try {
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/session_tokens/create')
    if (response.data.data) {
      cardAddProxy.converge.sessionToken = response.data.data.sessionToken
    } else {
      cardAddProxy.apiCallSessionToken.error = response.data.error
    }
    return response.data
  } catch (e) {
    if (e instanceof Error) {
      cardAddProxy.apiCallSessionToken.error = e.message
    }
  } finally {
    cardAddProxy.apiCallSessionToken.loading = false
  }
}

export async function executeFetchSessionTokenForCreditCard (): Promise<Response | null | undefined> {
  cardAddProxy.apiCallSessionToken.loading = true
  cardAddProxy.apiCallSessionToken.error = null
  try {
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/session_tokens/create')
    if (response.data.data) {
      cardAddProxy.converge.sessionToken = response.data.data.sessionToken
    } else {
      cardAddProxy.apiCallSessionToken.error = response.data.error
    }
    return response.data
  } catch (e) {
    if (e instanceof Error) {
      cardAddProxy.apiCallSessionToken.error = e.message
    }
  } finally {
    cardAddProxy.apiCallSessionToken.loading = false
  }
}

//TODO: remove temporary function for lb
export async function executeFetchSessionTokenLightbox (): Promise<Response | null | undefined> {
  cardAddProxy.apiCallSessionToken.loading = true
  cardAddProxy.apiCallSessionToken.error = null
  try {
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/session_tokens/lightbox')
    if (response.data.data) {
      cardAddProxy.converge.sessionToken = response.data.data.sessionToken
    } else {
      cardAddProxy.apiCallSessionToken.error = response.data.error
    }
    return response.data
  } catch (e) {
    if (e instanceof Error) {
      cardAddProxy.apiCallSessionToken.error = e.message
    }
  } finally {
    cardAddProxy.apiCallSessionToken.loading = false
  }
}
